<template>
  <div id="taskmanager">
    <h5 class="text-xl mb-4">
      传输任务
      <a class="text-blue-700 cursor-pointer" @click="back"><small>返回</small></a>
    </h5>
    <hr class="mb-8">
    <TaskIndicator v-if="tasks.length" />
    <div class="my-4">
      <button v-if="tasks.length" :disabled="!tasks.filter(t => t.succeeded).length"
              class="ui small teal button"
              @click="clear_succeeded">清除已完成任务</button>
      <button v-if="tasks.length" :disabled="!failed_tasks.length"
              class="ui small button"
              @click="retry_failed">重试失败的任务</button>
    </div>
    <template v-if="tasks.length">
      <div class="ui top attached tabular menu">
        <div v-if="upload_tasks.length" class="item upload-tab" data-tab="upload">
          上传
          {{ upload_speed }}
        </div>
        <div v-if="download_tasks.length" class="item download-tab" data-tab="download">
          下载
          {{ download_speed }}
        </div>
      </div>
      <div v-if="upload_tasks.length" class="ui bottom attached tab segment upload-tab" data-tab="upload">
        <div class="ui relaxed list">
          <TaskEntry v-for="(e, index) in upload_tasks" :key="index" :task="e" />
        </div>
      </div>
      <div v-if="download_tasks.length" class="ui bottom attached tab segment download-tab" data-tab="download">
        <div class="ui relaxed list">
          <TaskEntry v-for="(e, index) in download_tasks" :key="index" :task="e" />
        </div>
      </div>
    </template>
    <div v-else class="ui message">
      没有任务
    </div>
  </div>
</template>

<script>
import TaskEntry from './task.vue'
import TaskIndicator from './task-indicator'

export default {
  name: 'TaskManager',
  props: [],
  components: {
    TaskEntry,
    TaskIndicator,
  },
  data: function () {
    return {
    };
  },
  computed: {
    tasks() {
      var tasks = this.$store.state.tasks;
      tasks.sort(this.cmp_tasks);
      return tasks;
    },
    failed_tasks() {
      return this.tasks.filter(t => t.failed);
    },
    upload_tasks() {
      return this.tasks.filter(t => t.type == "upload");
    },
    download_tasks() {
      return this.tasks.filter(t => t.type == "download");
    },
    download_speed() {
      var bps = this.$store.getters.download_bps;
      return this.bytes_to_human(bps) + "/s";
    },
    upload_speed() {
      var bps = this.$store.getters.upload_bps;
      return this.bytes_to_human(bps) + "/s";
    },
  },
  asyncComputed: {
  },
  filters: {
  },
  methods: {
    retry_failed() {
      this.failed_tasks.forEach(t => {
        t.retry(t.name);
      });
    },
    clear_succeeded() {
      this.$store.commit('delete_succeeded_tasks');
      if (this.tasks.length == 0) {
        this.show_success("任务已清空");
        this.$router.go(-1);
      }
    },
    back() {
      this.$router.go(-1);
    },
    task_state_num(t) {
      switch (t.state) {
        case 'running':
          return 1;
        case 'created':
          return 2;
        case 'done':
          return 3
        case 'failed':
          return 4;
        default:
          return 5;
      }
    },
    cmp_tasks(a, b) {
      var sa = this.task_state_num(a);
      var sb = this.task_state_num(b);
      if (sa != sb) {
        return sa - sb;
      } else {
        return a.name - b.name;
      }
    },
  },
  mounted() {
    if (this.tasks.length) {
      this.$('.menu .item').tab();
      if (this.upload_tasks.length) {
        this.$(".upload-tab").addClass("active");
      } else if (this.download_tasks.length) {
        this.$(".download-tab").addClass("active");
      }
    }
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.section {
  margin-top: 10px;
  margin-bottom: 20px;
}
</style>
